import { useState } from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';

interface Product {
  id: number;
  name: string;
  description: string;
  image: string;
  category: string;
}

const UrunlerPage = () => {
  const [selectedCategory, setSelectedCategory] = useState('Tümü');

  const categories = ['Tümü', 'Tarot Kartları', 'Kristaller', 'Enerji Ürünleri', 'Eğitim Setleri', 'Özel Koleksiyonlar'];

  const products: Product[] = [
    {
      id: 1,
      name: 'Mistik Tarot Destesi',
      description: 'Özel tasarım 78 kartlık profesyonel tarot destesi. Altın yaldızlı, premium kalite.',
      image: 'https://public.readdy.ai/ai/img_res/8f53aae319397de4322f2ec48449608f.jpg',
      category: 'Tarot Kartları'
    },
    {
      id: 2,
      name: 'Ay Enerjisi Tarot Seti',
      description: 'Ay enerjileriyle uyumlu özel tarot kartları. Gümüş detaylı, kutulu set.',
      image: 'https://readdy.ai/api/search-image?query=moon%20phases%20tarot%20cards%20with%20silver%20details%20on%20dark%20mystical%20background%20celestial%20themed%20deck%20professional%20product%20shot%20elegant%20packaging%20box%20spiritual%20moonlight%20atmosphere%20Deniz%20Erin%20brand%20name%20on%20box&width=600&height=600&seq=tarot2&orientation=squarish',
      category: 'Tarot Kartları'
    },
    {
      id: 3,
      name: 'Ametist Meditasyon Küresi',
      description: 'Doğal ametist kristalinden üretilmiş meditasyon küresi. Ahşap standlı.',
      image: 'https://readdy.ai/api/search-image?query=natural%20amethyst%20crystal%20sphere%20ball%20on%20wooden%20stand%20purple%20gemstone%20with%20inner%20clarity%20professional%20product%20photography%20on%20clean%20white%20background%20spiritual%20healing%20stone%20high%20quality%20detailed%20texture%20Deniz%20Erin%20brand%20label&width=600&height=600&seq=crystal1&orientation=squarish',
      category: 'Kristaller'
    },
    {
      id: 4,
      name: 'Gül Kuvars Şifa Taşı Seti',
      description: '7 parça gül kuvars şifa taşı seti. Çakra dengeleme için ideal.',
      image: 'https://readdy.ai/api/search-image?query=rose%20quartz%20healing%20stones%20set%20of%20seven%20pieces%20pink%20crystals%20arranged%20beautifully%20chakra%20balancing%20stones%20on%20soft%20fabric%20professional%20product%20photography%20gentle%20pink%20tones%20spiritual%20wellness%20atmosphere%20Deniz%20Erin%20brand%20packaging&width=600&height=600&seq=crystal2&orientation=squarish',
      category: 'Kristaller'
    },
    {
      id: 5,
      name: 'Siyah Turmalin Koruma Taşı',
      description: 'Negatif enerjilere karşı güçlü koruma sağlayan doğal siyah turmalin.',
      image: 'https://readdy.ai/api/search-image?query=natural%20black%20tourmaline%20protection%20stone%20raw%20crystal%20with%20deep%20black%20color%20professional%20product%20shot%20on%20neutral%20background%20powerful%20protective%20gemstone%20high%20quality%20mineral%20specimen%20Deniz%20Erin%20brand%20tag&width=600&height=600&seq=crystal3&orientation=squarish',
      category: 'Kristaller'
    },
    {
      id: 6,
      name: 'Enerji Meditasyon Yastığı',
      description: 'Özel kumaştan üretilmiş, enerji çalışmaları için tasarlanmış meditasyon yastığı.',
      image: 'https://readdy.ai/api/search-image?query=luxury%20meditation%20cushion%20pillow%20in%20deep%20purple%20and%20gold%20colors%20spiritual%20healing%20energy%20design%20elegant%20fabric%20with%20mystical%20patterns%20professional%20product%20photography%20peaceful%20zen%20atmosphere%20Deniz%20Erin%20brand%20embroidery&width=600&height=600&seq=energy1&orientation=squarish',
      category: 'Enerji Ürünleri'
    },
    {
      id: 7,
      name: 'Premium Temizleme Seti',
      description: 'Beyaz adaçayı, palo santo ve lavanta içeren premium temizleme seti.',
      image: 'https://readdy.ai/api/search-image?query=sage%20smudge%20stick%20bundle%20with%20palo%20santo%20and%20lavender%20spiritual%20cleansing%20set%20natural%20dried%20herbs%20on%20rustic%20wooden%20background%20professional%20product%20photography%20earthy%20tones%20peaceful%20atmosphere%20Deniz%20Erin%20brand%20label%20on%20packaging&width=600&height=600&seq=energy2&orientation=squarish',
      category: 'Enerji Ürünleri'
    },
    {
      id: 8,
      name: '7 Çakra Mum Seti',
      description: '7 çakraya özel renkli mumlar. Doğal balmumu ve esansiyel yağlar.',
      image: 'https://readdy.ai/api/search-image?query=seven%20chakra%20balancing%20candles%20in%20rainbow%20colors%20natural%20beeswax%20candles%20arranged%20in%20row%20spiritual%20healing%20atmosphere%20professional%20product%20shot%20colorful%20gradient%20from%20red%20to%20violet%20peaceful%20zen%20setting%20Deniz%20Erin%20brand%20on%20box&width=600&height=600&seq=energy3&orientation=squarish',
      category: 'Enerji Ürünleri'
    },
    {
      id: 9,
      name: 'Tarot Başlangıç Eğitim Seti',
      description: 'Başlangıç seviyesi tarot eğitimi için kapsamlı set. Kart destesi ve rehber kitap dahil.',
      image: 'https://readdy.ai/api/search-image?query=tarot%20reading%20education%20kit%20with%20cards%20and%20guidebook%20complete%20learning%20package%20on%20elegant%20purple%20background%20professional%20training%20materials%20mystical%20and%20educational%20atmosphere%20high%20quality%20product%20photography%20Deniz%20Erin%20brand%20on%20book%20cover&width=600&height=600&seq=edu1&orientation=squarish',
      category: 'Eğitim Setleri'
    },
    {
      id: 10,
      name: 'Kristal Terapi Eğitim Seti',
      description: 'Kristal terapi eğitimi için gerekli tüm taşlar ve eğitim materyalleri.',
      image: 'https://readdy.ai/api/search-image?query=crystal%20healing%20education%20set%20with%20various%20gemstones%20and%20learning%20materials%20complete%20therapy%20training%20kit%20colorful%20crystals%20arranged%20beautifully%20professional%20product%20photography%20spiritual%20wellness%20theme%20Deniz%20Erin%20brand%20packaging&width=600&height=600&seq=edu2&orientation=squarish',
      category: 'Eğitim Setleri'
    },
    {
      id: 11,
      name: 'Meditasyon Başlangıç Seti',
      description: 'Meditasyon pratiği için özel tasarlanmış kapsamlı başlangıç seti.',
      image: 'https://readdy.ai/api/search-image?query=meditation%20and%20mindfulness%20starter%20kit%20with%20cushion%20singing%20bowl%20and%20crystals%20complete%20zen%20practice%20set%20peaceful%20purple%20and%20gold%20tones%20professional%20product%20photography%20serene%20spiritual%20atmosphere%20Deniz%20Erin%20brand%20label&width=600&height=600&seq=edu3&orientation=squarish',
      category: 'Eğitim Setleri'
    },
    {
      id: 12,
      name: 'Ay Ritüelleri Lüks Koleksiyon',
      description: 'Dolunay ve yeniay ritüelleri için özel hazırlanmış lüks koleksiyon seti.',
      image: 'https://readdy.ai/api/search-image?query=luxury%20moon%20ritual%20collection%20set%20with%20candles%20crystals%20and%20ceremonial%20items%20elegant%20mystical%20package%20in%20silver%20and%20purple%20professional%20product%20photography%20celestial%20spiritual%20atmosphere%20premium%20quality%20Deniz%20Erin%20brand%20on%20luxury%20box&width=600&height=600&seq=special1&orientation=squarish',
      category: 'Özel Koleksiyonlar'
    },
    {
      id: 13,
      name: 'Bolluk ve Bereket Seti',
      description: 'Bolluk ve bereket çalışmaları için altın enerjili özel set.',
      image: 'https://readdy.ai/api/search-image?query=golden%20manifestation%20abundance%20set%20with%20citrine%20crystals%20and%20gold%20candles%20luxury%20spiritual%20prosperity%20kit%20warm%20golden%20tones%20professional%20product%20photography%20wealth%20and%20success%20energy%20theme%20Deniz%20Erin%20brand%20emblem&width=600&height=600&seq=special2&orientation=squarish',
      category: 'Özel Koleksiyonlar'
    },
    {
      id: 14,
      name: 'Koruma ve Arınma Koleksiyonu',
      description: 'Negatif enerjilerden korunma ve arınma için güçlü ürün koleksiyonu.',
      image: 'https://readdy.ai/api/search-image?query=protection%20and%20cleansing%20collection%20with%20black%20tourmaline%20sage%20and%20protective%20amulets%20spiritual%20defense%20kit%20on%20dark%20mystical%20background%20professional%20product%20shot%20powerful%20energy%20atmosphere%20Deniz%20Erin%20brand%20seal&width=600&height=600&seq=special3&orientation=squarish',
      category: 'Özel Koleksiyonlar'
    },
    {
      id: 15,
      name: 'Aşk ve İlişki Enerji Seti',
      description: 'Kalp çakrası ve aşk enerjisi çalışmaları için özel tasarlanmış romantik set.',
      image: 'https://readdy.ai/api/search-image?query=love%20and%20relationship%20energy%20set%20with%20rose%20quartz%20and%20pink%20candles%20romantic%20spiritual%20kit%20in%20soft%20pink%20tones%20heart%20chakra%20healing%20products%20professional%20product%20photography%20gentle%20loving%20atmosphere%20Deniz%20Erin%20brand%20on%20elegant%20box&width=600&height=600&seq=special4&orientation=squarish',
      category: 'Özel Koleksiyonlar'
    }
  ];

  const filteredProducts = selectedCategory === 'Tümü' 
    ? products 
    : products.filter(product => product.category === selectedCategory);

  return (
    <div className="min-h-screen bg-gradient-to-b from-white via-purple-50/30 to-white">
      <Navbar />
      
      {/* Hero Section */}
      <section className="pt-32 pb-16 px-6">
        <div className="max-w-7xl mx-auto text-center">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
          >
            <h1 className="font-serif text-5xl md:text-6xl font-bold text-primary-dark mb-6">
              Ürünlerimiz
            </h1>
            <p className="text-lg text-gray-600 max-w-3xl mx-auto leading-relaxed">
              Spiritüel yolculuğunuzda size eşlik edecek özenle seçilmiş ürünler. 
              Her biri pozitif enerji ve şifa amacıyla tasarlanmıştır.
            </p>
          </motion.div>
        </div>
      </section>

      {/* Category Filter */}
      <section className="pb-12 px-6">
        <div className="max-w-7xl mx-auto">
          <div className="flex flex-wrap justify-center gap-3">
            {categories.map((category) => (
              <button
                key={category}
                onClick={() => setSelectedCategory(category)}
                className={`px-6 py-2.5 rounded-full text-sm font-medium transition-all duration-300 whitespace-nowrap cursor-pointer ${
                  selectedCategory === category
                    ? 'bg-gold text-primary-dark shadow-lg shadow-gold/30'
                    : 'bg-white text-gray-600 hover:bg-purple-50 border border-gray-200'
                }`}
              >
                {category}
              </button>
            ))}
          </div>
        </div>
      </section>

      {/* Products Grid */}
      <section className="pb-20 px-6">
        <div className="max-w-7xl mx-auto">
          <motion.div 
            className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8"
            layout
          >
            {filteredProducts.map((product, index) => (
              <motion.div
                key={product.id}
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.6, delay: index * 0.1 }}
              >
                <Link
                  to={`/urunler/${product.id}`}
                  className="block bg-white rounded-2xl overflow-hidden shadow-lg hover:shadow-2xl transition-all duration-300 group cursor-pointer"
                  data-product-shop
                >
                  <div className="relative w-full h-80 overflow-hidden bg-gray-100">
                    <img
                      src={product.image}
                      alt={product.name}
                      className="w-full h-full object-cover object-top group-hover:scale-110 transition-transform duration-500"
                    />
                  </div>
                  <div className="p-6">
                    <span className="inline-block px-3 py-1 bg-purple-100 text-purple-700 rounded-full text-xs font-medium mb-3">
                      {product.category}
                    </span>
                    <h3 className="font-serif text-xl font-bold text-primary-dark mb-3 group-hover:text-gold transition-colors duration-300">
                      {product.name}
                    </h3>
                    <p className="text-gray-600 text-sm mb-4 leading-relaxed">
                      {product.description}
                    </p>
                    <div className="flex items-center justify-between">
                      <span className="text-gold font-semibold flex items-center space-x-2 whitespace-nowrap">
                        <span>Detaylı Bilgi Al</span>
                        <i className="ri-arrow-right-line group-hover:translate-x-1 transition-transform duration-300"></i>
                      </span>
                    </div>
                  </div>
                </Link>
              </motion.div>
            ))}
          </motion.div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-20 px-6 bg-gradient-to-r from-primary-dark via-purple-900 to-primary-dark">
        <div className="max-w-4xl mx-auto text-center">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
            viewport={{ once: true }}
          >
            <h2 className="font-serif text-4xl md:text-5xl font-bold text-white mb-6">
              Ürünler Hakkında Bilgi Almak İster misiniz?
            </h2>
            <p className="text-lg text-purple-200 mb-8 leading-relaxed">
              Size en uygun ürünleri seçmenizde yardımcı olmak için buradayım. 
              Randevu alarak ürünler hakkında detaylı bilgi alabilirsiniz.
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <a
                href="/randevu"
                className="px-8 py-4 bg-gold text-primary-dark rounded-full text-base font-medium hover:shadow-2xl hover:shadow-gold/50 transition-all duration-300 cursor-pointer whitespace-nowrap"
              >
                Randevu Al
              </a>
              <a
                href="/sohbet"
                className="px-8 py-4 bg-white text-primary-dark rounded-full text-base font-medium hover:shadow-2xl hover:shadow-white/30 transition-all duration-300 cursor-pointer whitespace-nowrap"
              >
                Sohbet Et
              </a>
            </div>
          </motion.div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default UrunlerPage;